<div class="h-screen grid grid-cols-1 md:grid-cols-[3fr_2fr]">
  <div class="flex flex-col justify-between p-4 sm:p-6 md:p-8">
    <app-nav-button></app-nav-button>
    <header class="flex flex-col w-full items-center mt-4">
      <img src="assets/icon/codijobs.png" class="h-14" alt="" />
      <h1 class="text-2xl font-bold text-gray-700 text-center">
        Bienvenido a <span class="text-primary">Codijobs</span>
      </h1>
      <p class="mt-2 text-center text-gray-600">
        Sabemos que ya tienes una cuenta en
        <a
          href="https://codideep.com"
          target="_blank"
          rel="noopener noreferrer"
          class="text-primary underline hover:text-primary/80"
        >
          Codideep</a
        >. Para completar tu perfil, ingresa tu DNI.
      </p>
      <p class="mt-10 text-xl text-gray-600">Completa tu perfil</p>
    </header>
    <section class="flex-1 mt-5 px-4 sm:px-8 md:px-16 lg:px-24 xl:px-36">
      <form
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        class="flex flex-col justify-between gap-y-10"
      >
        <div class="gap-6">
          <app-input-text
            label="DNI"
            placeholder="DNI"
            [control]="form.get('identificationDocument')"
          />
        </div>
        <app-loading-button
          [text]="'Completar perfil'"
          [loading]="loading"
          type="submit"
        >
        </app-loading-button>
      </form>
    </section>
  </div>
  <div class="hidden relative md:block">
    <img
      src="assets/img/abs1.jpg"
      alt="Imagen decorativa"
      class="w-full h-full object-cover absolute"
    />
  </div>
</div>
